import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/fee-groups',
    name: 'fee-groups',
    props: true,
    meta: {
      title: 'Fee groups'
    },
    component: () => import('@/views/fees/FeeGroupListView.vue')
  },
  {
    path: '/fee-groups/create',
    name: 'fee-group-create',
    props: true,
    meta: {
      title: 'Create Fee groups'
    },
    component: () => import('@/views/fees/FeeGroupCreateView.vue')
  },
  {
    path: '/fee-groups/:id',
    name: 'fee-group-edit',
    props: true,
    meta: {
      title: 'Edit Fee groups'
    },
    component: () => import('@/views/fees/FeeGroupEditView.vue')
  }
]

export default routes
